// extracted by mini-css-extract-plugin
module.exports = {"layout":"DefayltLayout_layout__mmFMA","layout_notop":"DefayltLayout_layout_notop__2Z2Ak"};